import { EscrowPartyTypeEnum, type IApp, type IEscrowInvitation } from 'src/graphql/schema';

import { useParty } from '../model';

import BeneficiaryInvitationCard from './BeneficiaryInvitationCard';
import DepositorSummaryCard from './DepositorSummaryCard';
import OrganizationCard from './OrganizationCard';

type Props = {
  app: Pick<IApp, 'owned' | 'ownerName' | 'ownerWebsite'>;
  escrowInvitation?: Pick<IEscrowInvitation, 'companyName' | 'userName' | 'userEmail'> | null;
};

// The summary card for the party in the surrounding PartyContextProvider, shared by every escrow type
const PartyCard = ({ app, escrowInvitation }: Props) => {
  const { type, party } = useParty();

  // Owning the app makes the current company the depositor; a beneficiary only sees the depositor read-only
  if (!app.owned && type === EscrowPartyTypeEnum.Depositor) return <DepositorSummaryCard app={app} />;

  if (party) return <OrganizationCard />;

  return escrowInvitation ? <BeneficiaryInvitationCard escrowInvitation={escrowInvitation} /> : null;
};

export default PartyCard;
